module.exports = __webpack_public_path__ + "static/media/jessica.17acf6d0.jpg";